module.exports = __webpack_public_path__ + "static/img/kawachi_04.6c27c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_04.jpg
// module id = uJC3
// module chunks = 0